import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useFinishImportLegalMattersMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportLegalMattersJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			systemJobId,
			options,
			impersonationContext,
		}: {
			systemJobId: string;
			options: Api.IImportLegalMattersOptions;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IImportLegalMattersJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `LegalMatter/importFromFile/${systemJobId}`,
				}),
				'POST',
				options
			);
		},
		onError,
		onSuccess,
		retry: false,
	});
};
